import { SIGN_UP_BONUS } from "constants/signUp";
import useTranslate from "hooks/useTranslate";
import { useAmountTextByCurrency } from "hooks/useAmountTextByCurrency";
import "./styles.sass";

type Props = {
  currencyCode: string;
};

export const RegistartionBanner = ({ currencyCode }: Props) => {
  const t = useTranslate();

  const amount = useAmountTextByCurrency({
    placeholderKey: "popup.reg.banner.amount",
    valuesByCurrency: SIGN_UP_BONUS,
    currencyCode,
  });

  return (
    <div className="RegistartionBanner">
      <div className="RegistartionBanner-left">
        <div className="RegistartionBanner-left__title">
          {t("popup.reg.banner.title")}
        </div>

        <div className="RegistartionBanner-left__content">
          {amount}
          <br />
          {t("popup.reg.banner.fs")}
        </div>
      </div>

      <img
        className="RegistartionBanner__img"
        src="https://diswdgcu9cfva.cloudfront.net/popup/glory/signup/gift.avif"
        alt="gift"
      />
    </div>
  );
};
